module.exports = __webpack_public_path__ + "img/newIndexBG.f858816b.jpg";